import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@pages/Login.vue')
    },
    {
        path: '',
        component: () => import('@pages/Dashboard.vue'),
        redirect: { name: 'Newsletters' },
        children: [
            {
                path: '/zakaznici',
                name: 'Customers',
                meta: { title: 'Zákazníci' },
                component: () => import('@components/customer/Customers.vue')
            },
            {
                path: '/newslettre',
                name: 'Newsletters',
                meta: { title: 'Newslettre' },
                component: () => import('@components/newsletters/Newsletters.vue')
            },
        ]
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import('@pages/404.vue')
    }
];


const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const isLoggedIn = !!localStorage.getItem('access-token');

    if (to.name !== 'Login' && !isLoggedIn) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
    } else {
        next();
    }
});

export default router;
